export default __webpack_public_path__ + "static/media/Uae_registration_overview.b07b3c76.svg";